import React from 'react';
import { Send, ShoppingBag, Truck } from 'lucide-react';
import FadeIn from './FadeIn';

const steps = [
  {
    number: '01',
    icon: Send,
    title: 'Send Your Grocery List',
    description: "Share your grocery list via WhatsApp — text, image, or voice note. Whatever's easiest for you.",
    image: 'https://images.unsplash.com/photo-1611532736597-de2d4265fba3?auto=format&fit=crop&w=600&q=80',
  },
  {
    number: '02',
    icon: ShoppingBag,
    title: 'We Procure Everything',
    description: 'Our team organizes the list and sources products from trusted vendors at the best prices.',
    image: 'https://images.unsplash.com/photo-1488459716781-31db52582fe9?auto=format&fit=crop&w=600&q=80',
  },
  {
    number: '03',
    icon: Truck,
    title: 'Delivered To Your Door',
    description: 'Groceries arrive neatly packed at your preferred time slot. No stress, no store visits.',
    image: 'https://images.unsplash.com/photo-1609220136736-443140cffec6?auto=format&fit=crop&w=600&q=80',
  },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="section-spacing bg-muted/40">
      <div className="content-width-wide">
        <FadeIn>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground tracking-tight text-center">
            How It Works
          </h2>
        </FadeIn>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8">
          {steps.map((step, i) => (
            <FadeIn key={i} delay={i * 0.15}>
              <div className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300">
                <img
                  src={step.image}
                  alt={step.title}
                  className="w-full h-44 object-cover"
                />
                <div className="p-6">
                  <div className="flex items-center gap-3 mb-3">
                    <span className="font-heading text-xs font-semibold bg-primary text-primary-foreground px-2.5 py-1 rounded-md tracking-wide">
                      {step.number}
                    </span>
                    <step.icon className="h-4 w-4 text-primary" strokeWidth={1.5} />
                  </div>
                  <h3 className="font-heading text-xl font-semibold text-foreground">
                    {step.title}
                  </h3>
                  <p className="mt-2 text-muted-foreground text-base leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  );
}
